(() => {
  const parseDiameter = (variant) => {
    const value = (variant?.options || []).find((option) => /(?:130|150|180|200)/.test(String(option)));
    return value ? Number((String(value).match(/130|150|180|200/) || [])[0]) : null;
  };
  const variantFor = (product, diameter) => product?.variants?.find((variant) => parseDiameter(variant) === Number(diameter)) || null;
  const money = (cents, format) => {
    const value = (Number(cents || 0) / 100).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return String(format || '{{ amount_with_comma_separator }} €').replace(/\{\{\s*(?:amount|amount_with_comma_separator)\s*\}\}/, value);
  };
  const optimizeLengths = (targetMm) => {
    const max = Math.max(1, Math.ceil(targetMm / 250) + 2);
    const candidates = [];
    for (let a = 0; a <= max; a += 1) for (let b = 0; b <= max; b += 1) for (let c = 0; c <= max; c += 1) {
      const count = a + b + c;
      if (!count || count > max) continue;
      const planned = a * 1000 + b * 500 + c * 250;
      candidates.push({ quantities: { length1000: a, length500: b, length250: c }, planned, count, deviation: Math.abs(planned - targetMm) });
    }
    candidates.sort((x, y) => x.deviation - y.deviation || x.count - y.count || y.quantities.length1000 - x.quantities.length1000 || y.quantities.length500 - x.quantities.length500 || y.quantities.length250 - x.quantities.length250);
    return candidates[0];
  };
  const readMeters = (value) => {
    const normalized = String(value || '').trim().replace(',', '.');
    if (!/^\d+(?:\.\d{1,3})?$/.test(normalized)) return null;
    const meters = Number(normalized);
    return meters >= 0.25 && meters <= 100 ? meters : null;
  };
  const readMillimeters = (value) => {
    const normalized = String(value ?? '').trim().replace(',', '.');
    if (!/^\d+(?:\.\d+)?$/.test(normalized)) return null;
    const millimeters = Number(normalized);
    return Number.isFinite(millimeters) && millimeters > 0 ? millimeters : null;
  };

  document.querySelectorAll('[data-msp-san-config]').forEach((root) => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const modal = root.closest('[data-msp-san-modal]');
    const dataNode = modal?.nextElementSibling;
    const config = JSON.parse(dataNode?.textContent || '{}');
    const products = config.products || {};
    const state = { step: 1, diameter: null, shaftCheck: null, shaftWidth: '', shaftDepth: '', length: '', fires: 1, expansion: false, offset: 'no', bend: null, insulation: 'none', accessories: new Set() };
    const steps = [...root.querySelectorAll('[data-step]')];
    const next = root.querySelector('[data-next]');
    const back = root.querySelector('[data-back]');
    const lengthInput = root.querySelector('[data-length]');
    const lengthError = root.querySelector('[data-length-error]');
    const expansion = root.querySelector('[data-expansion]');
    const expansionWrap = root.querySelector('[data-expansion-wrap]');
    const bends = root.querySelector('[data-bends]');
    const shaftFields = root.querySelector('[data-shaft-fields]');
    const shaftNote = root.querySelector('[data-shaft-note]');
    const linesNode = root.querySelector('[data-lines]');
    const facts = root.querySelector('[data-facts]');
    const totalNode = root.querySelector('[data-total]');
    const status = root.querySelector('[data-status]');
    const cart = root.querySelector('[data-cart]');
    const planNote = root.querySelector('[data-plan-note]');
    const accessoriesNode = root.querySelector('[data-accessories]');
    const rainInput = root.querySelector('[data-accessory="rain"]');
    const sketchImage = root.querySelector('[data-san-sketch-image]');
    let cartItems = [];
    let isAddingToCart = false;
    rainInput.disabled = true;
    rainInput.closest('label').classList.add('is-disabled');

    const selectButton = (group, value) => {
      root.querySelectorAll(`[data-choice="${group}"] button`).forEach((button) => {
        const selected = button.dataset.value === String(value);
        button.classList.toggle('is-selected', selected);
        button.setAttribute('aria-pressed', String(selected));
      });
    };
    selectButton('fires', 1); selectButton('offset', 'no'); selectButton('insulation', 'none');

    const addLine = (key, quantity, list, note = '', label = '') => {
      if (!quantity) return;
      const product = products[key];
      const variant = key === 'cleaningClosure' && product?.variants?.length === 1 ? product.variants[0] : variantFor(product, state.diameter);
      list.push({ key, product, variant, quantity, note, label });
    };
    const shaftAssessment = () => {
      if (state.shaftCheck !== 'yes') return { label: state.shaftCheck === 'no' ? 'Ohne Schachtprüfung' : '–', detail: '', tone: '' };
      const shaftWidthMm = readMillimeters(state.shaftWidth);
      const shaftDepthMm = readMillimeters(state.shaftDepth);
      if (!(shaftWidthMm && shaftDepthMm)) return { label: 'Schachtmaße noch nicht vollständig', detail: 'Bitte Breite und Tiefe eingeben.', tone: '' };
      if (!state.diameter) return { label: 'Durchmesser fehlt', detail: 'Bitte zuerst einen Rohrdurchmesser auswählen.', tone: '' };
      const insulationMm = state.insulation === 'insulation20' ? 20 : state.insulation === 'insulation25' ? 25 : 0;
      const minimumMm = Number(state.diameter) + 1.2 + 20 + insulationMm * 2;
      const greenThresholdMm = minimumMm + 10;
      const narrowestShaftMm = Math.min(shaftWidthMm, shaftDepthMm);
      const formatMm = (value) => value.toLocaleString('de-DE', { minimumFractionDigits: 1, maximumFractionDigits: 1 });
      const measureDetail = `Geometrisches Mindestmaß: ${formatMm(minimumMm)} mm. Grün ab ${formatMm(greenThresholdMm)} mm in Breite und Tiefe.`;
      if (narrowestShaftMm < minimumMm) return { label: '✕ Voraussichtlich zu klein', detail: `Das angegebene Schachtmaß ist für die gewählte Verrohrung voraussichtlich nicht ausreichend. ${measureDetail}`, tone: 'fail' };
      if (narrowestShaftMm < greenThresholdMm) return { label: '⚠ Knapp – bitte prüfen', detail: `Die Verrohrung passt rechnerisch in den angegebenen Schacht, die Montagefreiheit ist jedoch gering. Bitte mögliche Engstellen und Versätze prüfen. ${measureDetail}`, tone: 'warning' };
      return { label: '✓ Voraussichtlich passend', detail: `Das angegebene Schachtmaß bietet nach unserer Planungsberechnung ausreichend Platz für die gewählte Verrohrung. ${measureDetail}`, tone: 'pass' };
    };
    const buildLines = () => {
      if (!state.diameter) return { list: [], plan: null };
      const meters = readMeters(state.length);
      const plan = meters ? optimizeLengths(Math.round(meters * 1000)) : null;
      const list = [];
      let pipeIssue = '';
      addLine('condensate', 1, list, 'Automatischer unterer Abschluss');
      addLine('cleaning', 1, list, 'Automatisch enthalten');
      addLine('cleaningClosure', 1, list, 'Automatisch außen ergänzt', 'Reinigungsverschluss / Edelstahlkamintür außen');
      if (plan) {
        const pipeQuantities = { ...plan.quantities };
        const requiredLoops = Number(state.fires);
        if (pipeQuantities.length1000 >= requiredLoops) {
          pipeQuantities.length1000 -= requiredLoops;
          addLine('lengthLoop', requiredLoops, list, 'Ersetzt je ein normales 1000-mm-Element; V1-Nennlänge unverändert');
          Object.entries(pipeQuantities).forEach(([key, qty]) => addLine(key, qty, list, 'V1-Planung mit Nennlänge'));
        } else {
          pipeIssue = `Für ${requiredLoops} ${requiredLoops === 1 ? 'Feuerstättenanschluss' : 'Feuerstättenanschlüsse'} stehen in der Längenplanung nur ${pipeQuantities.length1000} ersetzbare 1000-mm-Elemente zur Verfügung.`;
          list.push({ key: 'pipeReview', product: { title: 'Rohrlängen – Konfiguration bitte fachlich prüfen' }, variant: null, quantity: 1, note: pipeIssue, review: true, blocking: true });
        }
      }
      addLine('fire', Number(state.fires), list, '90° mit Wassernase');
      const expansionQuantity = Math.max(0, Number(state.fires) - 1);
      if (expansionQuantity && state.expansion) addLine('expansion', expansionQuantity, list, 'Ein Dehnungsausgleich je weiterem Anschluss; abwählbar');
      if (state.offset === 'yes' && state.bend) addLine(state.bend, 2, list, 'Zwei Bögen führen in den Verzug und zurück in die Senkrechte');
      if (plan) addLine('spacer', Math.ceil(meters / 2), list, 'V1-Raster: ein Abstandshalter je angefangene 2 m');
      if (state.insulation !== 'none' && plan) addLine(state.insulation, Math.ceil(meters), list, 'Menge nach 1-m-Nennlänge, ohne Zuschlag');
      addLine('top', 1, list, 'Automatischer Standardabschluss');
      state.accessories.forEach((key) => addLine(key, 1, list, 'Optionales Zubehör'));
      return { list, plan, pipeIssue };
    };
    const render = () => {
      const meters = readMeters(state.length);
      const { list, plan, pipeIssue } = buildLines();
      const shaft = shaftAssessment();
      facts.innerHTML = `<div><dt>Durchmesser</dt><dd>${state.diameter ? `Ø ${state.diameter} mm` : '–'}</dd></div><div><dt>Sanierungslänge</dt><dd>${meters ? `${String(meters).replace('.', ',')} m` : '–'}</dd></div><div><dt>Feuerstätten</dt><dd>${state.fires}</dd></div><div><dt>Schachtprüfung</dt><dd>${shaft.label}</dd></div><div><dt>Dämmung</dt><dd>${state.insulation === 'none' ? 'keine' : state.insulation === 'insulation20' ? '20 mm' : '25 mm'}</dd></div><div><dt>Versatz</dt><dd>${state.offset === 'yes' ? (state.bend ? products[state.bend]?.title || 'Ja' : 'Ja, Winkel offen') : 'Nein'}</dd></div>`;
      shaftNote.replaceChildren();
      shaftNote.classList.remove('is-pass', 'is-warning', 'is-fail');
      if (state.shaftCheck === 'yes') {
        const shaftTitle = document.createElement('strong');
        shaftTitle.className = 'msp-san-shaft-status__title';
        shaftTitle.textContent = shaft.label;
        shaftNote.append(shaftTitle);
        if (shaft.detail) {
          const shaftDetail = document.createElement('span');
          shaftDetail.className = 'msp-san-shaft-status__detail';
          shaftDetail.textContent = shaft.detail;
          shaftNote.append(shaftDetail);
        }
        if (shaft.tone) shaftNote.classList.add(`is-${shaft.tone}`);
      } else if (state.shaftCheck === 'no') shaftNote.textContent = 'Ohne Schachtprüfung';
      shaftNote.dataset.checkSignature = `${state.diameter || ''}|${state.shaftWidth}|${state.shaftDepth}|${state.insulation}`;
      linesNode.replaceChildren();
      let sum = 0; let complete = Boolean(state.diameter && plan); let available = true;
      list.forEach((line) => {
        const row = document.createElement('article'); row.className = 'msp-san-line';
        row.dataset.productKey = line.key;
        row.dataset.variantId = line.variant?.id || '';
        row.dataset.diameter = state.diameter || '';
        const title = document.createElement('div'); const strong = document.createElement('strong');
        strong.textContent = `${line.quantity} × ${line.label || line.product?.title || 'Produkt nicht geladen'}`;
        const small = document.createElement('small'); small.textContent = line.note; title.append(strong, small);
        const detail = document.createElement('span');
        if (line.review) { row.classList.add('msp-san-line--review'); detail.textContent = 'Nicht berechnet'; if (line.blocking) complete = false; }
        else if (!line.variant) { detail.textContent = 'Variante fehlt'; complete = false; }
        else if (!line.variant.available) { detail.textContent = 'Nicht verfügbar'; available = false; }
        else { const price = Number(line.variant.price) * line.quantity; sum += price; detail.textContent = `${money(line.variant.price, config.moneyFormat)} · ${money(price, config.moneyFormat)}`; }
        row.append(title, detail); linesNode.append(row);
      });
      const plannedLength = meters ? meters.toLocaleString('de-DE', { minimumFractionDigits: 1, maximumFractionDigits: 3 }) : '';
      planNote.textContent = plan
        ? `Geplante Sanierungslänge: ${plannedLength} m – ${pipeIssue ? 'Konfiguration bitte fachlich prüfen.' : 'passend zusammengestellt.'}`
        : 'Nach Eingabe der Länge wird die Rohrkombination berechnet.';
      totalNode.textContent = complete && available ? money(sum, config.moneyFormat) : '–';
      status.textContent = pipeIssue ? 'Konfiguration bitte fachlich prüfen. Es wurde keine unvollständige Rohrkombination berechnet.' : !complete ? 'Konfiguration noch nicht vollständig oder Variante nicht hinterlegt.' : !available ? 'Mindestens eine Variante ist derzeit nicht verfügbar.' : 'Planung vollständig. Warenkorb bleibt in V1 auf QA-PENDING.';
      const validLines = list.filter((line) => !line.review && line.variant?.available && Number.isInteger(Number(line.quantity)) && Number(line.quantity) > 0);
      const cartReady = complete && available && validLines.length === list.length && validLines.length > 0;
      cartItems = cartReady ? validLines.map((line) => ({
        id: Number(line.variant.id),
        quantity: Number(line.quantity),
        properties: { _Konfiguration: 'Schornsteinsanierung', _Durchmesser: `Ø ${state.diameter} mm` },
      })) : [];
      cart.disabled = !cartReady || isAddingToCart;
      if (!isAddingToCart) cart.textContent = 'KOMPLETT IN DEN WARENKORB';
      if (cartReady) status.textContent = 'Planung vollständig und bereit für den Warenkorb.';
      accessoriesNode.hidden = state.step < 6;
      const sketchState = Math.min(3, Math.max(1, Number(state.fires) || 1));
      if (sketchImage && sketchImage.dataset.state !== String(sketchState)) {
        sketchImage.src = sketchImage.dataset[`src-${sketchState}`];
        sketchImage.alt = `Schematischer Schornsteinschnitt mit ${sketchState === 1 ? 'einem' : sketchState} Feuerstättenanschlüssen`;
        sketchImage.dataset.state = String(sketchState);
      }
    };
    const validateStep = () => {
      if (state.step === 1) return Boolean(state.diameter);
      if (state.step === 2) {
        if (!state.shaftCheck) return false;
        if (state.shaftCheck === 'yes') return Boolean(readMillimeters(state.shaftWidth) && readMillimeters(state.shaftDepth));
      }
      if (state.step === 3) { const valid = Boolean(readMeters(state.length)); lengthError.textContent = valid ? '' : 'Bitte eine Länge zwischen 0,25 m und 100 m eingeben.'; return valid; }
      if (state.step === 5 && state.offset === 'yes') return Boolean(state.bend);
      return true;
    };
    const showStep = () => {
      steps.forEach((step) => { step.hidden = Number(step.dataset.step) !== state.step; });
      root.querySelector('[data-progress-current]').textContent = state.step;
      root.querySelector('[data-progress-bar]').style.width = `${(state.step / 6) * 100}%`;
      back.disabled = state.step === 1; next.textContent = state.step === 6 ? 'Ergebnis anzeigen' : 'Weiter'; render();
    };
    root.querySelectorAll('[data-choice] button').forEach((button) => button.addEventListener('click', () => {
      const group = button.closest('[data-choice]').dataset.choice; const value = button.dataset.value;
      state[group] = group === 'fires' ? Number(value) : value; selectButton(group, value);
      if (group === 'shaftCheck') shaftFields.hidden = value !== 'yes';
      if (group === 'fires') { expansionWrap.hidden = Number(value) < 2; state.expansion = Number(value) >= 2; expansion.checked = state.expansion; }
      if (group === 'offset') { bends.hidden = value !== 'yes'; if (value === 'no') state.bend = null; }
      render();
    }));
    root.querySelector('[data-shaft-width]').addEventListener('input', (event) => { state.shaftWidth = event.target.value; render(); });
    root.querySelector('[data-shaft-depth]').addEventListener('input', (event) => { state.shaftDepth = event.target.value; render(); });
    lengthInput.addEventListener('input', (event) => { state.length = event.target.value; lengthError.textContent = ''; render(); });
    expansion.addEventListener('change', () => { state.expansion = expansion.checked; render(); });
    root.querySelectorAll('[data-accessory]').forEach((input) => input.addEventListener('change', () => { input.checked ? state.accessories.add(input.dataset.accessory) : state.accessories.delete(input.dataset.accessory); render(); }));
    cart.addEventListener('click', async () => {
      if (isAddingToCart || cart.disabled || !cartItems.length) return;
      const items = cartItems.map((item) => ({ ...item, properties: { ...item.properties } }));
      isAddingToCart = true;
      cart.disabled = true;
      cart.textContent = 'WIRD HINZUGEFÜGT…';
      status.textContent = 'Die vollständige Konfiguration wird in den Warenkorb gelegt…';
      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
          body: JSON.stringify({ items, sections: ['cart-drawer', 'cart-icon-bubble'], sections_url: window.location.pathname }),
        });
        const result = await response.json().catch(() => ({}));
        if (!response.ok) throw new Error(result.description || result.message || `HTTP ${response.status}`);
        status.textContent = 'Die vollständige Konfiguration wurde in den Warenkorb gelegt.';
        document.dispatchEvent(new CustomEvent('msp:cart-refresh'));
        window.dispatchEvent(new CustomEvent('cartUpdated', { detail: result }));
        const drawer = document.querySelector('cart-drawer');
        if (drawer?.renderContents && result.sections) drawer.renderContents(result);
      } catch (error) {
        console.error('[MSP Sanierung Warenkorb]', error);
        status.textContent = 'Die Konfiguration konnte nicht in den Warenkorb gelegt werden. Bitte prüfen Sie Ihre Auswahl und versuchen Sie es erneut.';
      } finally {
        isAddingToCart = false;
        cart.disabled = !cartItems.length;
        cart.textContent = 'KOMPLETT IN DEN WARENKORB';
      }
    });
    next.addEventListener('click', () => { if (!validateStep()) return; if (state.step < 6) { state.step += 1; showStep(); } else { root.querySelector('.msp-san-config__summary').scrollIntoView({ behavior: 'smooth', block: 'start' }); } });
    back.addEventListener('click', () => { if (state.step > 1) { state.step -= 1; showStep(); } });
    showStep();
  });

  document.querySelectorAll('[data-msp-san-trigger]').forEach((trigger) => {
    const modal = document.getElementById(trigger.getAttribute('aria-controls'));
    if (!modal) return;
    const close = modal.querySelector('.msp-san-modal__close'); let previousFocus;
    const closeModal = () => { modal.hidden = true; document.documentElement.classList.remove('msp-san-modal-open'); trigger.setAttribute('aria-expanded', 'false'); (previousFocus || trigger).focus(); };
    trigger.addEventListener('click', () => { previousFocus = document.activeElement; modal.hidden = false; document.documentElement.classList.add('msp-san-modal-open'); trigger.setAttribute('aria-expanded', 'true'); close.focus(); });
    close.addEventListener('click', closeModal); modal.addEventListener('click', (event) => { if (event.target === modal) closeModal(); });
    document.addEventListener('keydown', (event) => { if (!modal.hidden && event.key === 'Escape') closeModal(); });
  });
})();
